export const URLS = {
  API_AUTH: 'https://api.ea-auth.dominusse.com/',
  API_URL: 'https://api.ea.dominusse.com/api/',

  // INVITATION ROUT (USING "API_URL")
  INVITE_INFO: 'user/expert/external?id=',

  // EXPERT PAGE
  EXPERT_FULL_DATA: 'user/expert?id=',

  // AUTH
  LOGIN: 'login',
  VALIDATION: 'login/confirm?devicePlatform=ANDROID',
  REFRESH: 'refresh',
  // user/registration only stores a pending registration (no account yet) — this send-code/confirm
  // pair on the auth server (mirroring login/login-confirm) verifies the phone and only then
  // triggers account creation on the main API via its internal finalizeRegistration callback.
  REGISTRATION_SEND_CODE: 'registration',
  REGISTRATION_CONFIRM: 'registration/confirm?devicePlatform=ANDROID',

  // API
  CITIES: 'v1/ref/cities',
  TRANSLATION: 'uilabel?language=',

  // USER
  REGISTRATION: 'user/registration',
  USER_PROFILE: 'user/retrieveProfileData',
  EXPERT_PROFILE: 'user/retrieveUserData',
  WORKHOURS: 'workhours',
  FACILITIES: 'expertFacilities',
  AVATAR: 'images/download',
  CONTACT_CHECK: 'contacts/check',
  FREE_HOURS: 'workhours/getFreeHours',

  // APPOINTMENT
  CREATE_APPOINTMENT: 'appointment/create',
  LIST_APPOINTMENT: 'appointment/list',
  UPDATE_APPOINTMENT_STATUS: 'appointment/updateStatus',
};